import { Injectable } from '@angular/core';
import { LegendItem } from '@groundworks/ngx-groundworks-ui';

const LEGEND_ITEMS: LegendItem[] = [
  { label: 'High Capacity', type: 'capacity-high' },
  { label: 'Low Capacity', type: 'capacity-low' },
  { label: 'Customer Satisfaction Visit', type: 'punchwork' },
  { label: 'Unavailable', type: 'unavailable' },
];

@Injectable({ providedIn: 'root' })
export class CapacityService {
  getLegendItems(): LegendItem[] {
    return LEGEND_ITEMS;
  }
}
